import React, { useEffect } from "react";
import { Order } from "@/types/order";
import { getAuthenticatedPages } from "@/utils/helpers";
import OrdersTable from "./orders-table";
import ItemsTable from "./items-table";
import { useOrders } from "./hooks";
import storage from "@/utils/storage";

export type TableView = "orders" | "items";

interface Props {
  data: Order[];
}

const Orders: React.FC<Props> = ({ data: orders }) => {
  const isBrandPage = getAuthenticatedPages().brand;
  const {
    view,
    setView,
    sidebarOpen,
    setSidebarOpen,
    selectedOrder,
    setSelectedOrder,
  } = useOrders();

  const tableStates = {
    view,
    setView,
    sidebarOpen,
    setSidebarOpen,
    selectedOrder,
    setSelectedOrder,
  };

  useEffect(() => {
    return () => {
      storage.removeItem("bid");
    };
  }, []);

  return (
    <div className="w-full rounded-lg border border-gray-200 p-6">
      {isBrandPage && (
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-1.5 mb-8">
            <h3 className="text-2xl font-semibold">Orders</h3>
            <p className="text-primary">
              Track and manage your orders efficiently.
            </p>
          </div>
        </div>
      )}
      {view === "orders" ? (
        <OrdersTable data={orders} tableStates={tableStates} />
      ) : (
        <ItemsTable data={orders} tableStates={tableStates} />
      )}
    </div>
  );
};

export default Orders;
